import { Icon } from '@chakra-ui/react';

export const ChatBubble = (props) => (
  <Icon viewBox="0 0 42 39" fill="none" {...props}>
    <path
      d="M21.0001 1.54541C10.1565 1.54541 1.36377 8.8734 1.36377 17.9027C1.44436 20.5815 2.2159 23.194 3.60356 25.4868C4.99123 27.7795 6.9479 29.6747 9.2838 30.9885C8.8118 32.2711 8.1556 33.478 7.3357 34.5713C7.1149 34.8938 6.99901 35.2766 7.004 35.6674C7.009 36.0582 7.1346 36.4379 7.3637 36.7546C7.5927 37.0713 7.914 37.3095 8.2836 37.4366C8.6532 37.5638 9.053 37.5736 9.4284 37.4649C12.0517 36.7011 14.5208 35.4836 16.7238 33.8675C18.1338 34.1318 19.5655 34.2632 21.0001 34.26C31.8438 34.26 40.6365 26.932 40.6365 17.9027C40.6365 8.8735 31.8438 1.54541 21.0001 1.54541Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4546 14.6364H27.5455"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M14.4546 21.1818H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </Icon>
);
